import script from "./CheckoutFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutFooter.vue?vue&type=script&setup=true&lang=js"

import "./css/common.scss?vue&type=style&index=0&id=230ca62c&lang=scss&scoped=true"

import exportComponent from "/builds/macys/polaris/app/bag-and-checkout/bag-and-checkout-app/._tmpdirxxx/.node/lib/node_modules/@core/vue-cli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-230ca62c"]])

export default __exports__